export default function Reviews() {
  const reviews = [
    {
      id: 1,
      name: "Maria Silva",
      rating: 5,
      date: "Há 2 semanas",
      text: "Produtos fresquíssimos e de excelente qualidade! Sempre compro aqui e nunca me decepciono. O atendimento é impecável e os preços são justos. Recomendo muito!",
      avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20happy%20brazilian%20woman%20smiling%20customer%20testimonial%20photo%20clean%20white%20background%20natural%20lighting%20friendly%20expression%20high%20quality%20headshot&width=100&height=100&seq=review1&orientation=squarish"
    },
    {
      id: 2,
      name: "João Santos",
      rating: 5,
      date: "Há 1 mês",
      text: "A melhor hortifruti de Paulínia! Verduras sempre frescas, frutas selecionadas e uma variedade incrível. A equipe é super atenciosa e o ambiente é muito limpo.",
      avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20happy%20brazilian%20man%20smiling%20customer%20testimonial%20photo%20clean%20white%20background%20natural%20lighting%20friendly%20expression%20high%20quality%20headshot&width=100&height=100&seq=review2&orientation=squarish"
    },
    {
      id: 3,
      name: "Ana Paula Costa",
      rating: 5,
      date: "Há 3 semanas",
      text: "Adoro fazer minhas compras no Rancho da Verdura! Os produtos são de primeira qualidade e sempre encontro tudo que preciso. O preço é justo pela qualidade oferecida.",
      avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20happy%20brazilian%20woman%20with%20glasses%20smiling%20customer%20testimonial%20photo%20clean%20white%20background%20natural%20lighting%20friendly%20expression%20high%20quality%20headshot&width=100&height=100&seq=review3&orientation=squarish"
    }
  ];

  const renderStars = (rating: number) => {
    return (
      <div className="flex gap-1">
        {[...Array(5)].map((_, index) => (
          <i
            key={index}
            className={`ri-star-fill text-base sm:text-lg ${
              index < rating ? 'text-[#FFC107]' : 'text-gray-300'
            }`}
          ></i>
        ))}
      </div>
    );
  };

  return (
    <section id="reviews" className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <span className="text-[#9bc53d] text-sm font-semibold tracking-wider uppercase">
            Depoimentos
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2d5016] mt-4 mb-4 sm:mb-6">
            Nossos Clientes
          </h2>
          <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto mb-6 sm:mb-8 px-4">
            Veja o que nossos clientes dizem sobre nós
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-6 sm:mb-8">
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, index) => (
                  <i key={index} className="ri-star-fill text-xl sm:text-2xl text-[#FFC107]"></i>
                ))}
              </div>
              <span className="text-xl sm:text-2xl font-bold text-[#2d5016]">5.0</span>
            </div>
            <div className="h-px w-16 sm:h-8 sm:w-px bg-gray-300"></div>
            <div className="text-center sm:text-left">
              <p className="text-xs sm:text-sm text-gray-600">Baseado em</p>
              <p className="text-base sm:text-lg font-semibold text-[#2d5016]">200+ avaliações</p>
            </div>
          </div>

          <a
            href="https://www.google.com/search?q=Rancho+da+Verdura+Paulínia"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#2d5016] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-base font-semibold hover:bg-[#9bc53d] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-google-fill text-lg sm:text-xl"></i>
            Ver Todas as Avaliações no Google
          </a>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-start gap-3 sm:gap-4 mb-4">
                <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full overflow-hidden flex-shrink-0 border-2 border-[#9bc53d]">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-bold text-[#2d5016] text-base sm:text-lg mb-1 truncate">
                    {review.name}
                  </h3>
                  <div className="flex items-center gap-2 mb-1">
                    {renderStars(review.rating)}
                  </div>
                  <p className="text-xs text-gray-500">{review.date}</p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed text-sm">
                "{review.text}"
              </p>
              <div className="mt-4 pt-4 border-t border-gray-200">
                <div className="flex items-center gap-2 text-gray-500 text-xs">
                  <i className="ri-google-fill text-sm sm:text-base"></i>
                  <span>Avaliação do Google</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 bg-gradient-to-br from-[#2d5016] to-[#9bc53d] rounded-2xl p-6 sm:p-8 md:p-12 text-center text-white shadow-2xl">
          <h3 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4">Sua Opinião é Importante!</h3>
          <p className="text-base sm:text-lg mb-4 sm:mb-6 text-white/90 max-w-2xl mx-auto px-4">
            Já comprou conosco? Compartilhe sua experiência e ajude outros clientes a conhecerem nosso trabalho.
          </p>
          <a
            href="https://www.google.com/search?q=Rancho+da+Verdura+Paulínia"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white text-[#2d5016] px-6 sm:px-8 py-3 sm:py-4 rounded-full text-sm sm:text-base font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-star-line text-lg sm:text-xl"></i>
            Deixar uma Avaliação
          </a>
        </div>
      </div>
    </section>
  );
}
